export default __webpack_public_path__ + "static/media/2.e1b5f763.png";